import { Partner } from '@/domain/models/partner/partner-model'
import { PartnerDescription as PartnerDescriptionModel } from '@/domain/models/partner/partner-description-model'
import { PartnerDetail } from '@/domain/usecases/partner/partner-detail'
import { PartnerDescription } from '@/domain/usecases/partner/partner-description'
import { importRemote } from '@/main/routes/helpers/loaders'
import { queryClient } from '@/infra/http'
import { configurationService } from '@/data/services/configuration/configuration-service'
import { Configuration } from '@/data/services/configuration/configuration-service-types'

export type PartnerDetailLoadDataType = {
  partner: Partner.Model
  description: PartnerDescriptionModel.Model[]
  configurations: Configuration.Model[]
}

/**
 * Loads partner detail and description for internal company manager
 * Fetches both partner info and description in parallel
 */
export async function loadPartnerDetail(id: string): Promise<PartnerDetailLoadDataType> {
  const [partner, descriptionResult, configurations] = await Promise.all([
    importRemote<PartnerDetail>('makeRemotePartnerDetail', queryClient).then(remote =>
      remote.get(id)
    ),
    importRemote<PartnerDescription>('makeRemotePartnerDescription', queryClient).then(remote =>
      remote.get(id)
    ),
    configurationService.getAllFromInstitution(id)
  ])

  // API returns array of descriptions (one per language), but interface type is incorrect
  const description = descriptionResult as unknown as PartnerDescriptionModel.Model[]

  return {
    partner,
    description,
    configurations
  }
}
